<template>
  <div class="tab-content warehouse-amazon-tab-content">
    <div id="top" class="tab-pane" :class="activeTab('top')">
      <top :currentTab="tab" />
    </div>
    <div id="amazon-info" class="tab-pane" :class="activeTab('amazon-info')">
      <amazon-info :currentTab="tab" />
    </div>
    <div id="multi-channel-service" class="tab-pane" :class="activeTab('multi-channel-service')">
      <multi-channel-service :currentTab="tab" />
    </div>
    <div id="receive-amount-setting" class="tab-pane" :class="activeTab('receive-amount-setting')">
      <receive-amount-setting :currentTab="tab" />
    </div>
  </div>
</template>
<script>
import Top from './Top'
import AmazonInfo from './AmazonInfo'
import MultiChannelService from './MultiChannelService'
import ReceiveAmountSetting from './ReceiveAmountSetting'

export default {
  components: {
    Top,
    AmazonInfo,
    MultiChannelService,
    ReceiveAmountSetting
  },
  props: {
    tab: {
      type: String,
      default: 'top'
    }
  },
  methods: {
    activeTab (tabName) {
      return this.tab === tabName ? 'active' : ''
    }
  }
}
</script>
<style scoped>
.warehouse-amazon-tab-content #amazon-info {
  max-width: 920px;
}
.warehouse-amazon-tab-content #multi-channel-service {
  max-width: 920px;
}
.warehouse-amazon-tab-content #receive-amount-setting {
  max-width: 840px;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAmazon/TabContent.vue